// extracted by mini-css-extract-plugin
export default {"action":"getReportCloneSuccessNotificationNode_action__sDy4W"};